export default "__VITE_ASSET__K4_Db1NQ__"